import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { inr } from "@/lib/format";
import { primeConsumerCache } from "@/lib/offline";
import { Card } from "@/components/ui/card";
import { Truck, PackageCheck, ShoppingBag, Undo2, Flag } from "lucide-react";

const Tile = ({ icon: Icon, label, sub, to, testid, tone }) => {
  const navigate = useNavigate();
  return (
    <button onClick={() => navigate(to)} data-testid={testid}
      className={`rounded-2xl border p-5 text-left bg-card active:scale-[0.99] transition-transform flex flex-col gap-3 ${tone || ""}`}>
      <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary"><Icon className="h-6 w-6" /></div>
      <div>
        <div className="font-semibold text-base">{label}</div>
        <div className="text-xs text-muted-foreground">{sub}</div>
      </div>
    </button>
  );
};

export default function DriverHome() {
  const [s, setS] = useState(null);
  const load = () => api.get("/reports/driver-day").then((r) => setS(r.data)).catch(() => {});
  useEffect(() => { load(); primeConsumerCache(); }, []);

  return (
    <div className="space-y-4 fade-up">
      <div>
        <h1 className="font-head text-xl font-bold">Today</h1>
        <p className="text-sm text-muted-foreground">Record everything you carry, deliver and collect.</p>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <Tile icon={Truck} label="Load cylinders" sub="Start of day" to="/driver/load" testid="driver-home-load-tile" />
        <Tile icon={PackageCheck} label="Deliver to consumer" sub="With consumer no" to="/driver/deliver" testid="driver-home-deliver-tile" />
        <Tile icon={ShoppingBag} label="Non-consumer sale" sub="Cash / UPI sale" to="/driver/sale" testid="driver-home-nonconsumer-tile" tone="border-amber-200" />
        <Tile icon={Undo2} label="Returns" sub="Unsold cylinders" to="/driver/returns" testid="driver-home-returns-tile" />
        <Tile icon={Flag} label="End of day" sub="Review & close" to="/driver/eod" testid="driver-home-eod-tile" />
      </div>

      {s && (
        <div className="sticky bottom-3 mt-4 rounded-2xl border bg-card shadow-lg p-4" data-testid="driver-summary-bar">
          <div className="grid grid-cols-4 gap-2 text-center">
            <div><div className="text-[11px] text-muted-foreground">Loaded</div><div className="font-semibold tabular-nums">{s.total_loaded}</div></div>
            <div><div className="text-[11px] text-muted-foreground">Delivered</div><div className="font-semibold tabular-nums">{s.total_delivered}</div></div>
            <div><div className="text-[11px] text-muted-foreground">Cash</div><div className="font-semibold tabular-nums text-sm">{inr(s.cash_total)}</div></div>
            <div><div className="text-[11px] text-muted-foreground">UPI</div><div className="font-semibold tabular-nums text-sm">{inr(s.upi_total)}</div></div>
          </div>
        </div>
      )}
    </div>
  );
}
